import React, { useState } from "react";
import { GlobalConsumer } from "../../context/GlobalContext";

const ShareTheLove = ({ onCloseSection }) => {
  const [copied, setCopied] = useState(false);

  const handleClickShare = status => {
    const refCode = document.getElementById("ref-code").innerText;
    let link;
    switch (status) {
      case "facebook":
        link = `http://www.facebook.com/sharer/sharer.php?u=https://www.mylocale.co.uk/invite/${refCode}`;
        break;
      case "twitter":
        link = `http://twitter.com/share?url=https://www.mylocale.co.uk/invite/${refCode}`;
        break;
      case "whatsapp":
        link = `https://wa.me/?text=https://www.mylocale.co.uk/invite/${refCode}`;
        break;
      default:
        link = null;
        break;
    }
    if (link) {
      window.location.href = link;
    }
  };

  const handleCopy = () => {
    const refCode = document.getElementById("ref-code").innerText;
    const copyTex = `https://mylocale.co.uk/invite/${refCode}`;
    try {
      const el = document.createElement("textarea");
      el.value = copyTex;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setCopied(true);
    } catch (error) {
      console.log(error);
    }
  };

  const closeSection = () => {
    if (onCloseSection) {
      onCloseSection("shareTheLove");
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="head-general with-back visible-xs">
        <a onClick={closeSection} className="back">
          <img src="/png/chevron-left.png" />
        </a>
        <h4>Share The Love</h4>
        <a className="close" />
      </div>
      {/* Header */}
      <GlobalConsumer>
        {({ user }) => {
          return (
            <div className="container">
              <div className="static feedback share-help">
                <div className="profile-desktop">
                  <h4 className="hide-xs">Share the love</h4>
                  <ul className="list">
                    <li className="white-bg padding-box mt-10px">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span className="number">1</span>
                          <p>
                            <span className="bold">
                              Gift your friend{" "}
                              {user.ref.destinationGainAmount || 250} Local E
                              eCoins
                            </span>
                            <span>Sharing the code below</span>
                          </p>
                        </div>
                        <p>
                          <img src="/svg/feedback1.svg" alt="" />
                        </p>
                      </div>
                    </li>

                    <li className="white-bg padding-box mt-10px">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span className="number">2</span>
                          <p>
                            <span className="bold">When they order</span>
                            <span>with Local E for the first time</span>
                          </p>
                        </div>
                        <p>
                          <img src="/svg/feedback2.svg" alt="" />
                        </p>
                      </div>
                    </li>

                    <li className="white-bg padding-box mt-10px">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span className="number">3</span>
                          <p>
                            <span className="bold">You{"'"}re rewarded</span>
                            <span>
                              with {user.ref.sourceGainAmount || 250} Local E
                              eCoins!
                            </span>
                          </p>
                        </div>
                        <p>
                          <img src="/svg/feedback3.svg" alt="" />
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                {/* .profile-desktop */}

                <div
                  className="white-bg mt-10px your-code cursor-pointer"
                  onClick={handleCopy}
                >
                  <p>Your code is </p>

                  <h5 id="ref-code">
                    {user.ref.refCode} <icon className="icon icon-shape" />
                  </h5>

                  {(copied && (
                    <p>
                      <strong>Copied !</strong>
                    </p>
                  )) ||
                    ""}
                </div>

                <div className="button visible-xs">
                  <a href="#" className="btn btn-blue">
                    Share With Friends!
                  </a>
                </div>

                <div className="social" style={{ display: "none" }}>
                  <div
                    className="white-bg mt-10px padding-box d-flex align-items-center"
                    onClick={() => handleClickShare("facebook")}
                  >
                    <div className="circle">
                      <img src="/png/facebook.png" />
                    </div>
                    <p>Share on Facebook </p>
                  </div>

                  <div
                    className="white-bg mt-10px padding-box d-flex align-items-center"
                    onClick={() => handleClickShare("twitter")}
                  >
                    <div className="circle">
                      <img src="/png/twitter.png" />
                    </div>
                    <p>Share on Twitter </p>
                  </div>

                  <div
                    className="white-bg mt-10px padding-box d-flex align-items-center"
                    onClick={() => handleClickShare("whatsapp")}
                  >
                    <div className="circle">
                      <img src="/png/whatsapp.png" />
                    </div>
                    <p>Share on Whatsapp </p>
                  </div>
                </div>
              </div>
              {/* .static */}
            </div>
          );
        }}
      </GlobalConsumer>
    </div>
  );
};
export default ShareTheLove;
